export const normalizeWards = (res: any) => res?.wards || [];
export const normalizeDistricts = (res: any) => res?.districts || [];

export const normalizeExternalFoodAndBeverageCategories = (res: any) =>
  res?.food_and_beverage_category_demand || [];

export const normalizeExternalFoodAndBeverageData = (res: any) => ({
  totalTransaction: res?.food_and_beverage_demand?.total_transaction || 0,
});

export const normalizeExternalFoodAndBeverageDeliveryData = (res: any) => ({
  totalTransaction:
    res?.food_and_beverage_delivery_demand?.total_transaction || 0,
});

export const normalizeStaticDemandData = (res: any) => ({
  totalTransaction: res?.static_demand?.total_transaction || 0,
});

export const normalizeNearbyLocationSummary = (res: any) =>
  res?.result?.location_type_summary || [];

export const normalizeNearbyLocationDetail = (res: any) =>
  res?.result?.locations || [];

export const normalizeSitePlanningPolygon = (res: any) =>
  res?.result?.map?.((planningPolygon: any) => {
    const newPlanningPolygon = planningPolygon;
    const newPlanningPolygonGeoJson = JSON.parse(newPlanningPolygon.geojson);
    return {
      geometry: newPlanningPolygonGeoJson.features[0].geometry,
      properties: planningPolygon,
    };
  }) || [];

export const normalizeExternalRetailData = (res: any) =>
  res?.total_revenue_last_3_month || 0;

export const normalizeWardDemographics = (res: any) => {
  return {
    ageRangePopulation: res?.summary?.age_range_population || [],
    totalArea: res?.summary?.total_area || 0,
    totalPopulation: res?.summary?.total_population || 0,
  };
};

export const normalizeBrandLocationType = (res: any) =>
  res?.result?.map((brand: any) => ({
    id: brand?.brand?.id,
    name: brand?.brand?.name,
  })) || [];

export const normalizePolygonArea = (Polygon: any) => (polygon: any) => {
  const { line_color } = polygon;
  const color = `rgb(${line_color?.[0] || 0},${line_color?.[1] || 0},${
    line_color?.[2] || 0
  })`;
  let coordinates = polygon?.geojson?.geometry?.coordinates?.[0];
  if (typeof coordinates?.[0]?.[0] == "number") {
    coordinates =
      coordinates.map?.((coords: Array<number>) => ({
        lat: coords[1],
        lng: coords[0],
      })) || [];
  } else {
    coordinates =
      coordinates?.[0]?.map?.((coords: Array<number>) => ({
        lat: coords[1],
        lng: coords[0],
      })) || [];
  }
  const res = new Polygon({
    paths: coordinates,
    strokeColor: color,
    strokeOpacity: 0.8,
    strokeWeight: 2,
    fillColor: color,
    fillOpacity: 0.35,
  });
  return res;
};

export const normalizeRadiusZone = (Circle: any, data: any) => {
  const { center, radius } = data;
  return new Circle({
    strokeColor: "#1c3f7a",
    strokeOpacity: 0.35,
    strokeWeight: 2,
    fillColor: "#1c3f7a",
    fillOpacity: 0.15,
    center,
    radius,
  });
};

export const normalizePolygon = (Polygon: any) => (polygon: any) => {
  const coordinates =
    polygon?.geometry?.coordinates?.[0]?.map?.((coords: Array<number>) => ({
      lat: coords[1],
      lng: coords[0],
    })) || [];
  const res = new Polygon({
    paths: coordinates,
    strokeColor: "#FF0000",
    strokeOpacity: 0.8,
    strokeWeight: 1,
    fillColor: "#FF0000",
    fillOpacity: 0.35,
  });
  return res;
};

export const normalizeHeatMap = (LatLng: any) => (data: any) => {
  return {
    location: new LatLng(data.latitude, data.longitude),
  };
};
